'use strict';

const badgeCategories = require('./BadgeCategories');

module.exports = [
	// COMMON BADGES

	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'methods-1',
		progressionKeys: ['A6', 'JV2.8', 'JV2.9']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'classes-1',
		progressionKeys: ['JV1.1', 'JV1.3']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'parameters-1',
		progressionKeys: ['OP2', 'BkP2']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'conditions-1',
		progressionKeys: ['OP3', 'RP2', 'YP1', 'JV3.2']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'logic-1',
		progressionKeys: ['OP3', 'RP2', 'YP1']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'booleans-1',
		progressionKeys: ['BD1']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'time-1',
		progressionKeys: ['JV4.4']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'fields-1',
		progressionKeys: ['JV2.1']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'variables-1',
		progressionKeys: ['OP2', 'JV2.1', 'A3', 'YD1']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'debugging-1',
		progressionKeys: ['YP1', 'YP3', 'YA4']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'loops-1',
		progressionKeys: ['YP1', 'YA2', 'BkP3', 'WP2', 'JV4.1', 'JV4.7', 'A5', 'OP3']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'flow-1',
		progressionKeys: ['JV4.3', 'BP2']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'arrays-1',
		progressionKeys: ['RP5', 'JV4.8', 'JV5.1', 'JV5.2', 'JV5.3', 'Ab4']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'random-1',
		progressionKeys: ['A3']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'operators-1',
		progressionKeys: ['JV2.6']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'ui-1',
		progressionKeys: ['OA3']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'strings-1',
		progressionKeys: ['JV2.3', 'PuP4']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'input-1',
		progressionKeys: ['A6']
	},

	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'stack-1',
		progressionKeys: ['RP5']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'algorithms-1',
		progressionKeys: ['PA1', 'PA2', 'PA3', 'YA1', 'YA2', 'YA3', 'YA4']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'general-1',
		progressionKeys: []
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'function/procedures-1',
		progressionKeys: ['BP3', 'BP4']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'data-1',
		progressionKeys: ['PD1']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'it-1',
		progressionKeys: ['PI1']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'timer-1',
		progressionKeys: ['YP2']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'swaps-1',
		progressionKeys: ['A3']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'switch-1',
		progressionKeys: ['JV3.7']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: '2D arrays?-1',
		progressionKeys: ['WP3']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'object-1',
		progressionKeys: ['JV6.1']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'abstraction-1',
		progressionKeys: ['Ab1']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'reals-1',
		progressionKeys: ['PuD5']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'scope-1',
		progressionKeys: ['BkP1']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'nesting-1',
		progressionKeys: ['RP1']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'generalisation-1',
		progressionKeys: ['G1']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'decomposition-1',
		progressionKeys: ['D1']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'evaluation-1',
		progressionKeys: ['E1']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'double-1',
		progressionKeys: ['PuP5']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'syntax-1',
		progressionKeys: ['JV2.1']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'networks-1',
		progressionKeys: ['PC1', 'PC2']
	},

	{
		category: badgeCategories.MINECRAFT,
		badgeId: 'mob-1',
		progressionKeys: ['JV1.1']
	},
	{
		category: badgeCategories.MINECRAFT,
		badgeId: 'command-1',
		progressionKeys: []
	},
	{
		category: badgeCategories.MINECRAFT,
		badgeId: 'communication-1',
		progressionKeys: []
	},
	{
		category: badgeCategories.MINECRAFT,
		badgeId: 'inventory-1',
		progressionKeys: ['RP5']
	},

	{
		category: badgeCategories.ROBLOX,
		badgeId: 'camera-1',
		progressionKeys: ['JV2.6']
	},
	{
		category: badgeCategories.ROBLOX,
		badgeId: 'physics-1',
		progressionKeys: ['A3']
	},
	{
		category: badgeCategories.ROBLOX,
		badgeId: 'presentation-1',
		progressionKeys: ['A3']
	},
	{
		category: badgeCategories.ROBLOX,
		badgeId: 'workspace-1',
		progressionKeys: []
	},
	{
		category: badgeCategories.ROBLOX,
		badgeId: 'templates-1',
		progressionKeys: []
	},

	// UNCOMMON BADGES

	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'methods-2',
		progressionKeys: ['JV2.8', 'JV2.9', 'A6']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'classes-2',
		progressionKeys: []
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'parameters-2',
		progressionKeys: ['RP2', 'A6']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'conditions-2',
		progressionKeys: ['OP3', 'BP1', 'A4', 'JV3.2']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'logic-2',
		progressionKeys: ['A4']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'booleans-2',
		progressionKeys: ['PuP3', 'PuD5']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'time-2',
		progressionKeys: []
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'fields-2',
		progressionKeys: ['JV2.6']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'variables-2',
		progressionKeys: ['JV2.6']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'debugging-2',
		progressionKeys: ['JV3.1']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'loops-2',
		progressionKeys: ['JV6.5']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'flow-2',
		progressionKeys: ['BJV4.3', 'BP2']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'arrays-2',
		progressionKeys: ['RP5', 'JV4.8']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'random-2',
		progressionKeys: []
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'operators-2',
		progressionKeys: ['JV2.6', 'A3']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'ui-2',
		progressionKeys: []
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'strings-2',
		progressionKeys: ['JV2.3']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'input-2',
		progressionKeys: ['PuP4']
	},

	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'stack-2',
		progressionKeys: ['RP5']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'algorithms-2',
		progressionKeys: ['OA1']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'general-2',
		progressionKeys: []
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'function/procedures-2',
		progressionKeys: ['RP3']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'data-2',
		progressionKeys: ['YD1']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'it-2',
		progressionKeys: ['YI']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'timer-2',
		progressionKeys: ['JV6.2', 'A6']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'swaps-2',
		progressionKeys: ['A3']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'switch-2',
		progressionKeys: ['JV3.7']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: '2D arrays?-2',
		progressionKeys: ['WP3']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'object-2',
		progressionKeys: ['JV6.1', 'JV6.2']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'abstraction-2',
		progressionKeys: ['Ab4']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'reals-2',
		progressionKeys: ['PuD5']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'scope-2',
		progressionKeys: ['BkP1']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'nesting-2',
		progressionKeys: ['JV4.5']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'generalisation-2',
		progressionKeys: ['G2']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'decomposition-2',
		progressionKeys: ['D2']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'evaluation-2',
		progressionKeys: ['E5']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'double-2',
		progressionKeys: ['PuP4']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'syntax-2',
		progressionKeys: ['JV2.1']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'networks-2',
		progressionKeys: []
	},

	{
		category: badgeCategories.MINECRAFT,
		badgeId: 'mob-2',
		progressionKeys: ['JV2.8']
	},
	{
		category: badgeCategories.MINECRAFT,
		badgeId: 'command-2',
		progressionKeys: []
	},
	{
		category: badgeCategories.MINECRAFT,
		badgeId: 'communication-2',
		progressionKeys: []
	},
	{
		category: badgeCategories.MINECRAFT,
		badgeId: 'inventory-2',
		progressionKeys: ['RP5']
	},

	{
		category: badgeCategories.ROBLOX,
		badgeId: 'camera-2',
		progressionKeys: []
	},
	{
		category: badgeCategories.ROBLOX,
		badgeId: 'physics-2',
		progressionKeys: ['A3']
	},
	{
		category: badgeCategories.ROBLOX,
		badgeId: 'presentation-2',
		progressionKeys: []
	},
	{
		category: badgeCategories.ROBLOX,
		badgeId: 'workspace-2',
		progressionKeys: []
	},
	{
		category: badgeCategories.ROBLOX,
		badgeId: 'templates-2',
		progressionKeys: []
	},

	// RARE BADGES

	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'classes-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'parameters-3',
		progressionKeys: ['JV2.2', 'JV2.3', 'JV2.4', 'JV2.5']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'conditions-3',
		progressionKeys: ['BP1']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'logic-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'booleans-3',
		progressionKeys: ['JV3.3']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'time-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'fields-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'variables-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'debugging-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'loops-3',
		progressionKeys: ['JV4.8']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'flow-3',
		progressionKeys: ['JV2.2', 'JV2.3', 'JV2.4', 'JV2.5']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'arrays-3',
		progressionKeys: ['RP5']
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'random-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'operators-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'ui-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'strings-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.LANGUAGE,
		badgeId: 'input-3',
		progressionKeys: []
	},

	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'stack-3',
		progressionKeys: ['RP5']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'algorithms-3',
		progressionKeys: ['WA1', 'RA1']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'general-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'function/procedures-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'data-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'it-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'timer-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'swaps-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'switch-3',
		progressionKeys: ['JV3.7']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: '2D arrays?-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'object-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'abstraction-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'reals-3',
		progressionKeys: ['PuD5']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'scope-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'nesting-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'generalisation-3',
		progressionKeys: ['G3']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'decomposition-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'evaluation-3',
		progressionKeys: ['E10']
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'double-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'syntax-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.COMPUTATIONAL,
		badgeId: 'networks-3',
		progressionKeys: []
	},

	{
		category: badgeCategories.MINECRAFT,
		badgeId: 'mob-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.MINECRAFT,
		badgeId: 'command-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.MINECRAFT,
		badgeId: 'communication-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.MINECRAFT,
		badgeId: 'inventory-3',
		progressionKeys: []
	},

	{
		category: badgeCategories.ROBLOX,
		badgeId: 'camera-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.ROBLOX,
		badgeId: 'physics-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.ROBLOX,
		badgeId: 'presentation-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.ROBLOX,
		badgeId: 'workspace-3',
		progressionKeys: []
	},
	{
		category: badgeCategories.ROBLOX,
		badgeId: 'templates-3',
		progressionKeys: []
	}
];
